import React, { useState, useRef } from "react";
import Form from "react-bootstrap/Form";
import Button from "react-bootstrap/Button";
import Row from "react-bootstrap/Row"
import Col from "react-bootstrap/Col"
import "./Login.css";
import Container from 'react-bootstrap/Container';
import Card from "react-bootstrap/Card"
import { Redirect } from 'react-router-dom';
import logo from "./../../logo.png"

export default function NewPassword(props) {
    console.log("from login", props);
    const [user, setUser] = useState<any>(props.location.data && props.location.data.user ? props.location.data.user : {})
    const [orgName, setOrgName] = useState(props.location.data && props.location.data.orgName ? props.location.data.orgName : "")
    const [state, setState] = useState(props.location.data && props.location.data.state ? props.location.data.state : "")
    const [isLoggedIn, setIsLoggedIn] = useState(props.location.data && props.location.data.user ? true : false);
    const [signIn, setSignIn] = useState(false)
    const [newPassword, setNewPassword] = useState("")
    const [confirmpassword, setConfirmPassword] = useState("");
    const form: any = useRef(null)
    function validateForm() {
        return newPassword.length > 0 && confirmpassword.length > 0;
    }

    function handleSubmit(event) {
        event.preventDefault();
        let apiUrl = "/api/v1/banyanidp/user/newpassword"
        console.log("user", user);
        let data: any = {
            "username": user.UserName,
            "password": newPassword,
            "orgName": orgName,
            "session": user.Session,
            "state": state
        }

        fetch(apiUrl, {
            method: 'POST', headers: {
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            body: JSON.stringify(data)
        })
            .then(res => res.json())
            .then(json => {
                if (state) {
                    if (json.data && json.data.Message) {
                        console.log("state !== null && state !== undefined && state !== ''", json)
                        window.location.href = json.data.Message;
                        return
                    }
                }
                setUser(json.data)
                console.log("user is logged in ...", json)
                //todo: navigate to dashboard
                if (json.data && json.data.Message) {
                    setSignIn(true)
                }
            })
    }

    const styles = {
        card: {
            borderRadius: 10,
        },
        cardHeader: {
            backgroundColor: "#031828",
        },
        cardImage: {
            height: '300px',
            width: '300px',
            align: 'center'
        }
    }

    if (!isLoggedIn) {
        return <Redirect to={{
            pathname: '/'
        }} />
    }

    if (signIn) {
        return <Redirect to={{
            pathname: '/dashboard',
            data: { user: user, orgName: orgName }

        }} />
    }

    return (
        <Container>
            <Row className="justify-content-center">
                <Col sm="6">
                    <Card style={styles.card} className="text-center">
                        <Card.Header style={styles.cardHeader}>
                            <Card.Img variant="top" src={logo} style={styles.cardImage} />
                        </Card.Header>

                        <Card.Body>
                            <Row>
                                <Col sm="12">
                                    <Form onSubmit={handleSubmit} ref={form} name="loginform">
                                        <Form.Group as={Row}>
                                            <Form.Label column sm="4">New Password</Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    type="password"
                                                    name="password"
                                                    id="password"
                                                    value={newPassword}
                                                    onChange={(e) => setNewPassword(e.target.value)}
                                                    placeholder="Enter New Password"

                                                /></Col>
                                        </Form.Group>
                                        <Form.Group as={Row}>
                                            <Form.Label column sm="4">Confirm Password</Form.Label>
                                            <Col sm="8">
                                                <Form.Control
                                                    type="password"
                                                    name="cofirmpassword"
                                                    id="cofirmpassword"
                                                    value={confirmpassword}
                                                    onChange={(e) => setConfirmPassword(e.target.value)}
                                                    placeholder="Confirm Password"

                                                /></Col>
                                        </Form.Group>
                                        <Button block size="lg" type="submit" disabled={!validateForm()}>
                                            Change Password
        </Button>
                                    </Form>
                                </Col>
                            </Row>
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </Container >
    );
}